import { useAuth } from './use-auth';

export function useFleetPermissions() {
  const { activeCompany, hasCompanyRole } = useAuth();

  const canView = activeCompany !== null;
  
  const canCreate = activeCompany && (
    hasCompanyRole(activeCompany.id, 'company_admin') ||
    hasCompanyRole(activeCompany.id, 'company_user')
  );

  const canEdit = canCreate;

  const canDelete = activeCompany && 
    hasCompanyRole(activeCompany.id, 'company_admin');

  const isViewer = activeCompany && 
    hasCompanyRole(activeCompany.id, 'fleet_viewer');

  const canApprove = activeCompany && (
    hasCompanyRole(activeCompany.id, 'company_admin') ||
    hasCompanyRole(activeCompany.id, 'fleet_manager')
  );

  const isFleetManager = activeCompany && 
    hasCompanyRole(activeCompany.id, 'fleet_manager');

  const isFleetOpsManager = activeCompany && 
    hasCompanyRole(activeCompany.id, 'fleet_ops_manager');

  const canMarkFuel = !isFleetOpsManager; // Ops managers cannot mark fuel/odometer

  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    isViewer,
    canApprove,
    isFleetManager,
    isFleetOpsManager,
    canMarkFuel
  };
}
